import LoadingButton from '@mui/lab/LoadingButton';

function Button(props) {
  return <LoadingButton variant="contained" color="primary" {...props} />;
}

export default Button;
